export default class WSPeer {


  _send(message) {
    message.to = this.id;
    this._server.send(message);
  }
}
